'use client';

import React from 'react';
import { Settings2 } from 'lucide-react';
import { cn } from '../lib/utils';

export interface CustomiseButtonProps {
  onClick: () => void;
  className?: string;
  label?: string;
}

export function CustomiseButton({ onClick, className, label = 'Customise' }: CustomiseButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-lg border border-slate-200 bg-white px-3 py-1.5',
        'font-body text-caption font-medium text-text-body transition-interactive duration-200',
        'hover:bg-surface-soft hover:text-text-heading',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-statura-green-accessible/30',
        className,
      )}
      title="Customise this view"
      aria-label={label === 'Customise' ? 'Customise this view' : label}
    >
      <Settings2 className="h-3.5 w-3.5" />
      {label}
    </button>
  );
}
